import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import {
  Droplets,
  ChevronDown,
  Calendar,
  BarChart3,
  Download,
  Info,
  Activity,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import { Spin, Space, Dropdown } from "antd";
import { CSVLink } from "react-csv";
import * as htmlToImage from "dom-to-image-more";
import { toast } from "react-toastify";
import { useTheme } from "../context/ThemeContext";
import { DatePicker, ConfigProvider, theme as antTheme } from "antd";
import { SwapOutlined } from "@ant-design/icons";
// Custom Hooks and Services from your second snippet
import { get } from "../Libraries/Ajax/HttpService";
import { useDistrict } from "../utils/DistrictContext";
import ExampleWithDistrict from "../pages/multipleselectDropdown";
import dayjs from "dayjs";
const WaterUsageTab = () => {
  const selectedDistrict = useDistrict();
  const domEl = useRef(null);
  const exportRef = useRef(null);
  const { theme, colors } = useTheme();
  const requestIdRef = useRef(0);

  // --- STATE FROM WATERS COMPONENT ---
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [toggle, setToggle] = useState(false); // false = Daily, true = Hourly

  const [defaultOption, setDefaultOption] = useState("Past Month");
  const [optiononenew, setOptiononenew] = useState("Day");
  const [slvalue, setSlvalue] = useState(1);

  // Custom Date States
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");
  const today = moment().format("YYYY-MM-DD");
  const [mainChartType, setMainChartType] = useState(() => {
    const user = JSON.parse(localStorage.getItem("MCData") || "{}");
    return user?.graphType || "line";
  });
  const [bottomChartType, setBottomChartType] = useState(() => {
    const user = JSON.parse(localStorage.getItem("MCData") || "{}");
    return user?.graphType || "bar";
  });
  const { RangePicker } = DatePicker;

  // Hourly Average Day Selection State
  const [selectedDayOption, setSelectedDayOption] = useState("Weekday");
  const dayOptions = [
    { id: "Weekday", label: "Weekdays" },
    { id: "Weekend", label: "Weekends" },
    { id: "Sundays", label: "Sunday" },
    { id: "Mondays", label: "Monday" },
    { id: "Tuesdays", label: "Tuesday" },
    { id: "Wednesdays", label: "Wednesday" },
    { id: "Thursdays", label: "Thursday" },
    { id: "Fridays", label: "Friday" },
    { id: "Saturdays", label: "Saturday" },
  ];

  const [callData, setcallData] = useState([]);
  const [color, setColor] = useState([
    "#00b8f1",
    "#4FC3F7",
    "#1E88E5",
    "#0060f1",
  ]);
  // const [myData, setmyData] = useState(["145330", "47197,L"]);
  // const [myDatas, setmyDatas] = useState([]);
  // const [mySample, setmySample] = useState(["145330-", "47197-L"]);
  const [myData, setmyData] = useState([]); // Changed from ["145330", ...]
  const [myDatas, setmyDatas] = useState([]); // Changed
  const [mySample, setmySample] = useState([]); // Changed from ["145330-", ...]

  const [merge, setMerge] = useState([]); // Line chart data
  const [mergenew, setMergenew] = useState([]); // Bottom chart data
  const [listOfUsers, setListofUsers] = useState([]);

  const districtKey = selectedDistrict?.selectedDistrict || "";

  const isSameArray = (a = [], b = []) => {
    if (a.length !== b.length) return false;
    return a.every((item, index) => item === b[index]);
  };

  const setArrayOnlyIfChanged = (setter, nextValue) => {
    setter((prev) => {
      if (isSameArray(prev, nextValue)) {
        return prev;
      }
      return nextValue;
    });
  };

  useEffect(() => {
    if (defaultOption === "Past Year" && optiononenew === "Hour") {
      setOptiononenew("Day");
    }

    if (defaultOption === "Past Day" && optiononenew === "Week") {
      setOptiononenew("Hour");
    }
  }, [defaultOption, optiononenew]);

  // --- DISTRICT INITIALIZATION ---
  // useEffect(() => {
  //   if (!selectedDistrict?.selectedDistrict) return;

  //   setOptiononenew("Week");
  //   setDefaultOption("Past Month");
  //   setSlvalue(1);

  //   switch (selectedDistrict.selectedDistrict) {
  //     case "FB151":
  //       setmyDatas([
  //         {
  //           meter: "288433",
  //           code: "DKRP0",
  //           name: "429700",
  //           accountName: "429700",
  //         },
  //       ]);
  //       setmyData(["288433"]);
  //       setmySample(["288433-"]);
  //       break;
  //     case "GPMD":
  //       setmyDatas([
  //         {
  //           meter: "145330",
  //           code: "PD",
  //           name: "Potable Domestic",
  //           accountName: "PHMSCM Holdings",
  //         },
  //       ]);
  //       setmyData(["145330"]);
  //       setmySample(["145330-"]);
  //       break;
  //     default:
  //       setmyDatas([]);
  //       setmyData([]);
  //       setmySample([]);
  //   }
  // }, [selectedDistrict]);

  // --- FETCH USER COLORS ---
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("MCData"));
    if (user?.userid) {
      get(`apis/user_color?user_id=${user.userid}`).then((res) => {
        if (res.data?.color) setColor(res.data.color);
      });
    }
  }, []);

  //   useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("MCData") || "{}");

  //   if (user?.graphType) {
  //     setMainChartType(user.graphType);
  //   }
  // }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("MCData") || "{}");

    if (user?.graphType) {
      setMainChartType(user.graphType);
      setBottomChartType(user.graphType);
    }
  }, []);

  // --- FETCH LINE CHART DATA ---
  useEffect(() => {
    if (defaultOption === "Custom" && (!customStartDate || !customEndDate))
      return;

    const controller = new AbortController();
    const currentRequestId = ++requestIdRef.current;

    const fetchWaterData = async () => {
      setLoading(true);

      try {
        let effectiveInterval = optiononenew;

        if (
          defaultOption === "Past Day" &&
          optiononenew !== "Day" &&
          optiononenew !== "Week"
        ) {
          effectiveInterval = "Hour";
        }

        const meterParam =
          mySample.length > 0 ? JSON.stringify(mySample) : "[]";

        let url = `apis/water/new?option=${effectiveInterval}&range_option=${defaultOption}&interval=${slvalue}&meterid=${meterParam}`;

        if (defaultOption === "Custom") {
          url += `&start=${customStartDate}&end=${customEndDate}`;
        }

        const res = await get(url, { signal: controller.signal });

        // Ignore outdated responses
        if (currentRequestId !== requestIdRef.current) return;

        const flowData = res?.data?.data?.water_flow || [];
        setListofUsers(res?.data?.data?.download_water_flow);

        const merged = flowData.map((item) => {
          const first = item[0] || {};
          const meterData = {};

          item.forEach((entry) => {
            const key =
              entry.unique_name || entry.meter_unique_name || "Total Flow";
            meterData[key] = entry.flow;
          });

          return {
            date: first.flow_date_check || first.option || "",
            ...meterData,
          };
        });

        setMerge(merged);
      } catch (err) {
        if (err.name !== "CanceledError") console.error(err);
      } finally {
        // Only latest request controls loader
        if (currentRequestId === requestIdRef.current) {
          setLoading(false);
        }
      }
    };

    fetchWaterData();

    return () => controller.abort();
  }, [
    mySample,
    optiononenew,
    slvalue,
    defaultOption,
    customStartDate,
    customEndDate,
    districtKey,
  ]);

  // --- FETCH BOTTOM CHART DATA (DAILY OR HOURLY AVERAGE) ---
  useEffect(() => {
    // Allow length 0 for the null case, only block if it exceeds 8
    if (myData.length >= 9) return;

    if (defaultOption === "Custom" && (!customStartDate || !customEndDate))
      return;

    const controller = new AbortController();
    setLoadings(true);

    const fetchAverageData = async () => {
      try {
        const selectionParam =
          mySample.length > 0 ? JSON.stringify(mySample) : "[]";

        if (!toggle) {
          // --- DAILY AVERAGE ---
          let url = `apis/daily_average?option=${defaultOption}&selected=${selectionParam}`;
          if (defaultOption === "Custom") {
            url += `&start_date=${customStartDate}&end_date=${customEndDate}`;
          }

          const res = await get(url, { signal: controller.signal });
          const dailyAvg = res.data.data.daily_avg_data.daily_avg.map(
            (item) => {
              const meterData = {};
              item?.value.forEach(({ meter_id, avg }) => {
                // Fallback to "Total Flow" if meter_id is null/missing
                const key = meter_id || "Total Flow";
                meterData[key] = avg;
              });
              return { day: item?.option_name, ...meterData };
            },
          );
          setMergenew(dailyAvg);
        } else {
          // --- HOURLY AVERAGE ---
          let url = `apis/hourly_average?option_one=${selectedDayOption}&option=${defaultOption}&option_two=Weekday&selected=${selectionParam}`;
          if (defaultOption === "Custom") {
            url += `&start_date=${customStartDate}&end_date=${customEndDate}`;
          }

          const res = await get(url, { signal: controller.signal });
          const hourlyArray = [];

          // Handle the specific nested structure for hourly average
          const hourlySource = res.data?.data?.hourly_avg?.option_one || [];

          hourlySource.forEach((item) => {
            const name = item[0]?.name || "Unknown";
            const meterData = {};
            item?.forEach(({ avg, meter_id }) => {
              // Fallback to "Total Flow" if meter_id is null/missing
              const key = meter_id || "Total Flow";
              meterData[key] = avg;
            });
            hourlyArray.push({ day: name, ...meterData });
          });
          setMergenew(hourlyArray);
        }
      } catch (err) {
        if (err.name !== "CanceledError") console.error(err);
      } finally {
        setLoadings(false);
      }
    };

    fetchAverageData();
    return () => controller.abort();
  }, [
    myData, // Important: triggers when selection is cleared to 0
    mySample,
    defaultOption,
    customStartDate,
    customEndDate,
    toggle, // Triggers when switching between Daily/Hourly
    selectedDayOption, // Triggers when changing weekday/weekend filter
    districtKey,
  ]);

  // const handleCallback = (childData) => {
  //   const selectedGroups = childData?.data?.data?.meters?.selected_meters || [];
  //   setcallData(selectedGroups);
  //   if (selectedGroups.length === 0) {
  //     setmyData([]);
  //     setmyDatas([]);
  //     setmySample([]);
  //     setMerge([]);
  //     setMergenew([]);
  //     return;
  //   }
  //   const validMeterIds = [];
  //   const validUniqueNames = [];

  //   selectedGroups.forEach((group) => {
  //     group.meters.forEach((meter) => {
  //       validMeterIds.push(meter.meter_unique_name);
  //       validUniqueNames.push(meter.unique_name);
  //     });
  //   });

  //   setmyData((prev) => prev.filter((id) => validMeterIds.includes(id)));

  //   setmyDatas((prev) =>
  //     prev.filter((item) => validMeterIds.includes(item.meter)),
  //   );
  //   setmySample((prev) =>
  //     prev.filter((unique) => validUniqueNames.includes(unique)),
  //   );
  // };

  const handleCallback = (childData) => {
    const selectedGroups = childData?.data?.data?.meters?.selected_meters || [];

    setcallData((prev) => {
      const prevStr = JSON.stringify(prev);
      const nextStr = JSON.stringify(selectedGroups);

      if (prevStr === nextStr) {
        return prev;
      }

      return selectedGroups;
    });

    if (selectedGroups.length === 0) {
      setArrayOnlyIfChanged(setmyData, []);
      setArrayOnlyIfChanged(setmyDatas, []);
      setArrayOnlyIfChanged(setmySample, []);
      return;
    }

    const validMeterIds = [];
    const validUniqueNames = [];

    selectedGroups.forEach((group) => {
      group.meters.forEach((meter) => {
        validMeterIds.push(meter.meter_unique_name);
        validUniqueNames.push(meter.unique_name);
      });
    });

    setmyData((prev) => {
      const next = prev.filter((id) => validMeterIds.includes(id));
      return isSameArray(prev, next) ? prev : next;
    });

    setmyDatas((prev) => {
      const next = prev.filter((item) => validMeterIds.includes(item.meter));

      if (JSON.stringify(prev) === JSON.stringify(next)) {
        return prev;
      }

      return next;
    });

    setmySample((prev) => {
      const next = prev.filter((unique) => validUniqueNames.includes(unique));
      return isSameArray(prev, next) ? prev : next;
    });
  };

  const disabledDate = (current) => {
    // Can not select days after today
    return current && current > moment().endOf("day");
  };
  const toggleAccountSelection = (meter, accountName) => {
    const param = meter.unique_name;
    const paramex = meter.meter_unique_name;

    if (myData.includes(paramex)) {
      setmyData((prev) => prev.filter((id) => id !== paramex));
      setmyDatas((prev) => prev.filter((item) => item.meter !== paramex));
      setmySample((prev) => prev.filter((id) => id !== param));
    } else {
      if (myDatas.length < 8) {
        setmyData((prev) => [...prev, paramex]);
        setmyDatas((prev) => [
          ...prev,
          {
            meter: paramex,
            code: meter.code,
            name: meter.name,
            accountName: accountName,
          },
        ]);
        setmySample((prev) => [...prev, param]);
      } else {
        toast.info("Only 8 Meters can be selected at a time");
      }
    }
  };

  const downloadImage = async () => {
    const node = exportRef.current;
    if (!node) return;

    try {
      const dataUrl = await htmlToImage.toPng(node, {
        backgroundColor: "#0a1628",
        pixelRatio: 2,
        filter: (node) => {
          if (node.classList?.contains("export-ignore")) {
            return false;
          }
          return true;
        },
      });

      const link = document.createElement("a");
      link.download = `water-usage-${selectedDistrict?.selectedDistrict}.png`;
      link.href = dataUrl;
      link.click();
    } catch (error) {
      toast.error("Could not download image");
    }
  };
  const handleRangeClick = (val) => {
    if (val === "YTD") {
      // Force January 1st of the current year to Today
      const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");

      setCustomStartDate(startOfYear);
      setCustomEndDate(today);

      // Set this to "Custom" so the useEffect appends &start and &end to the API URL
      setDefaultOption("Custom");
      setOptiononenew("Week"); // Default to Week for YTD to avoid chart clutter
    } else {
      setDefaultOption(val);
      setCustomStartDate("");
      setCustomEndDate("");
    }
  };
  const handleRangeChange = (dates, dateStrings) => {
    if (dateStrings && dateStrings[0] !== "" && dateStrings[1] !== "") {
      setCustomStartDate(dateStrings[0]);
      setCustomEndDate(dateStrings[1]);
    } else {
      setCustomStartDate("");
      setCustomEndDate("");
    }
  };
  const exportItems = [
    { label: <span onClick={downloadImage}>Download As PNG</span>, key: "0" },
    { type: "divider" },
    {
      label: (
        <CSVLink
          data={listOfUsers}
          filename={`water-usage-${defaultOption}.csv`}
        >
          Download As CSV
        </CSVLink>
      ),
      key: "1",
    },
  ];

  return (
    <div className="flex gap-6 mb-5 flex-wrap" ref={domEl}>
      {/* Left Sidebar - Accounts List */}
      <motion.div
        className="w-80 backdrop-blur-sm rounded-xl border p-6 shrink-0 max-[767px]:w-full max-[1300px]:w-full"
        style={{ backgroundColor: colors.cardBg, borderColor: colors.border }}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="space-y-6 overflow-y-auto pr-2 custom-scrollbar">
          {callData?.map((person, indexs) => (
            <div key={indexs} className="space-y-3">
              <div
                className="text-xs font-bold uppercase tracking-wider"
                style={{ color: colors.primary }}
              >
                {person.Overide_acc_name}
              </div>
              {person.meters.map((meter, idx) => {
                const isActive = myData.includes(meter.meter_unique_name);
                const meterColor =
                  color[myData.indexOf(meter.meter_unique_name)] || "#00b8f1";

                return (
                  <div
                    key={idx}
                    className="flex items-start gap-3 p-3 rounded-lg border transition-all duration-300 cursor-pointer"
                    style={{
                      background: isActive
                        ? `${colors.primary}20`
                        : `${colors.background}80`,
                      borderColor: isActive ? colors.primary : colors.border,
                      boxShadow: isActive
                        ? `0 0 20px ${colors.primary}30`
                        : "none",
                    }}
                    onClick={() =>
                      toggleAccountSelection(meter, person.Overide_acc_name)
                    }
                  >
                    <div
                      className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 border ${
                        isActive ? "border-[#00b8f1]" : "border-[#00b8f1]/30"
                      }`}
                      style={{
                        backgroundColor: isActive
                          ? `${meterColor}20`
                          : "transparent",
                      }}
                    >
                      <Droplets
                        className="w-4 h-4"
                        style={{
                          color: isActive ? meterColor : colors.textSecondary,
                        }}
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div
                        className="text-sm font-medium truncate"
                        style={{ color: colors.text }}
                      >
                        {meter.name}
                      </div>
                      <div
                        className="text-sm font-mono"
                        style={{
                          color: isActive
                            ? colors.primary
                            : colors.textSecondary,
                        }}
                      >
                        {meter.meter_id}
                        {meter.register_number && ` (${meter.register_number})`}
                      </div>
                      <div
                        className="text-xs mt-1"
                        style={{
                          color: colors.textSecondary,
                          opacity: 0.7,
                        }}
                      >
                        Range: {meter.date_range}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </motion.div>

      {/* Main Content Area */}
      <div className="flex-1 space-y-6 min-w-0" ref={exportRef}>
        {/* Filters */}
        <motion.div
          className="backdrop-blur-sm rounded-xl border p-6 export-ignore"
          style={{ backgroundColor: colors.cardBg, borderColor: colors.border }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <div className="flex flex-wrap items-end gap-1">
            {/* <div className="flex-1 min-w-[200px]"> */}
            <div className="w-[400px] shrink-0 max-[1900px]:w-full">
              <label
                className="text-xs mb-2 block"
                style={{ color: colors.primary }}
              >
                Accounts
              </label>
              <div className="w-full">
                <ExampleWithDistrict
                  parentCallback={handleCallback}
                  elementValue={myData}
                  selectedDistrict={districtKey}
                />
              </div>
            </div>

            <div className="flex-1 min-w-[150px]">
              {/* <label
                className="text-xs mb-2 block"
                style={{ color: colors.primary }}
              >
                Range | Interval | Custom
              </label> */}
              <div
                className="flex items-center gap-1 p-1 rounded-xl border w-full max-[1900px]:w-full justify-between flex-wrap"
                style={{
                  backgroundColor: colors.background,
                  borderColor: colors.border,
                }}
              >
                {/* --- SECTION 1: RANGE PRESETS --- */}
                <div className="flex items-center gap-1 flex-wrap">
                  {[
                    { label: "D", value: "Past Day" },
                    { label: "W", value: "Past Week" },
                    { label: "1M", value: "Past Month" },
                    { label: "3M", value: "Past 3 Months" },
                    { label: "6M", value: "Past 6 Months" },
                    { label: "YTD", value: "YTD" },
                    { label: "1Y", value: "Past Year" },
                  ].map((tp) => {
                    // Highlight YTD if dates match Jan 1st to today
                    const isYTD =
                      tp.value === "YTD" &&
                      customStartDate ===
                        moment().startOf("year").format("YYYY-MM-DD");
                    const isActive = defaultOption === tp.value || isYTD;

                    return (
                      <button
                        key={tp.value}
                        onClick={() => handleRangeClick(tp.value)}
                        className="px-3 py-1.5 rounded-lg text-xs font-bold transition-all cursor-pointer hover:opacity-80"
                        style={{
                          backgroundColor: isActive
                            ? `${colors.primary}20`
                            : "transparent",
                          color: isActive
                            ? colors.primary
                            : colors.textSecondary,
                          border: isActive
                            ? `1px solid ${colors.primary}40`
                            : "1px solid transparent",
                        }}
                      >
                        {tp.label}
                      </button>
                    );
                  })}
                </div>
                {/* Vertical Separator 2 */}
                <div
                  className="h-6 w-[1px] mx-1"
                  style={{ backgroundColor: colors.border }}
                />

                {/* --- SECTION 3: CALENDAR --- */}
                <ConfigProvider
                  theme={{
                    algorithm:
                      theme === "white"
                        ? antTheme.defaultAlgorithm
                        : antTheme.darkAlgorithm,
                    token: {
                      colorPrimary: colors.primary,
                      controlHeight: 32,
                      borderRadius: 8,
                    },
                  }}
                >
                  <RangePicker
                    value={[
                      customStartDate
                        ? dayjs(customStartDate, "YYYY-MM-DD")
                        : null,
                      customEndDate ? dayjs(customEndDate, "YYYY-MM-DD") : null,
                    ]}
                    onChange={(dates, strings) => {
                      handleRangeChange(dates, strings);
                      setDefaultOption("Custom");
                    }}
                    disabledDate={disabledDate}
                    placeholder={["Start", "End"]}
                    variant="borderless"
                    separator={
                      <SwapOutlined style={{ color: colors.textSecondary }} />
                    }
                    className="custom-range-picker cursor-pointer"
                    style={{ width: "230px" }}
                    classNames={{
                      popup: {
                        root: `mizu-calendar-popup calendar-${theme}`,
                      },
                    }}
                  />
                </ConfigProvider>
                {/* Vertical Separator 1 */}
                <div
                  className="h-6 w-[1px] mx-1"
                  style={{ backgroundColor: colors.border }}
                />

                {/* --- SECTION 2: INTERVAL SELECTOR (Hour, Day, Week) --- */}
                <div className="flex items-center gap-1">
                  {["Hour", "Day", "Week"]
                    .filter((intvl) => {
                      // If selected range is Past Year, hide Hour
                      if (defaultOption === "Past Year" && intvl === "Hour") {
                        return false;
                      }

                      // If selected range is Past Day, hide Week
                      if (defaultOption === "Past Day" && intvl === "Week") {
                        return false;
                      }

                      return true;
                    })
                    .map((intvl) => {
                      const isActive = optiononenew === intvl;

                      return (
                        <button
                          key={intvl}
                          onClick={() => setOptiononenew(intvl)}
                          className="px-3 py-1.5 rounded-lg text-[10px] font-black uppercase transition-all cursor-pointer hover:opacity-80"
                          style={{
                            backgroundColor: isActive
                              ? colors.primary
                              : "transparent",
                            color: isActive ? "#fff" : colors.textSecondary,
                          }}
                        >
                          {intvl}
                        </button>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="shrink-0 mb-[1px]">
              <Dropdown menu={{ items: exportItems }} trigger={["click"]}>
                <button
                  className="flex items-center justify-center w-[42px] h-[42px]  rounded-lg hover:shadow-lg hover:shadow-[#00b8f1]/30 transition-all duration-300"
                  style={{
                    background: `linear-gradient(to right, ${colors.primary}, ${colors.secondary})`,
                    color: colors.buttonText,
                  }}
                >
                  <Download className="w-5 h-5 text-white" />
                </button>
              </Dropdown>
            </div>
          </div>
        </motion.div>

        {/* Top Line Chart (Main Water Usage) */}
        {/* <motion.div
          className="bg-[#0f1f30]/50 backdrop-blur-sm rounded-xl border p-6 relative max-[800px]:overflow-x-scroll "
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          style={{
            backgroundColor: theme === "white" ? "#ffffff" : colors.glassEffect, // Light or Dark theme background
            border: `1px solid ${theme === "white" ? colors.border : `${colors.primary}15`}`, // Border based on theme
          }}
        >
          <div className="h-[400px] min-[1921px]:h-[500px] max-[800px]:w-[600px]">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <Spin size="large" />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  data={merge}
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke={colors.border}
                    vertical={false}
                  />
                  <XAxis
                    dataKey="date"
                    stroke="#BDB9B5"
                    style={{ fontSize: "10px" }}
                    tickMargin={10}
                    tickFormatter={(value) => {
                      if (!value) return "";
                      const date = moment(value);
                      if (!date.isValid()) {
                        return value;
                      }

                      if (optiononenew === "Months") {
                        return date.format("MMM YYYY"); 
                      }

                      return date.format("MMM DD, YYYY");
                    }}
                  />
                  <YAxis
                    stroke="#BDB9B5"
                    style={{ fontSize: "10px" }}
                    tickFormatter={(value) => value.toLocaleString("en-US")}
                  >
                    <Label
                      value="Gallons"
                      angle={-90}
                      position="insideLeft"
                      style={{ fill: "#BDB9B5", fontSize: "12px" }}
                    />
                  </YAxis>
                  <Tooltip
                    
                    contentStyle={{
                      backgroundColor:
                        theme === "white" ? "#ffffff" : colors.background,
                      border: `1px solid ${colors.primary}30`,
                      borderRadius: "8px",
                      boxShadow: `0 8px 32px ${colors.primary}30`,
                      color: colors.text,
                    }}
                   
                    formatter={(value, name) => [
                      `${value.toLocaleString()} Gallons`,
                      name,
                    ]}
                  />
                  <Legend
                    iconType="circle"
                    wrapperStyle={{ paddingTop: "20px" }}
                  />
                  {myDatas.map((item, index) => (
                    <Line
                      key={item.meter}
                      type="monotone"
                      dataKey={item.meter}
                      stroke={color[index % color.length]}
                      strokeWidth={2}
                      dot={{ fill: color[index % color.length], r: 4 }}
                      name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                      isAnimationActive={true}
                    />
                  ))}
                </LineChart>
              </ResponsiveContainer>
            )}
          </div>
        </motion.div> */}
        {/* Top Chart (Main Water Usage) */}
        <motion.div
          className="bg-[#0f1f30]/50 backdrop-blur-sm rounded-xl border p-6 relative max-[800px]:overflow-x-scroll"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          style={{
            backgroundColor: theme === "white" ? "#ffffff" : colors.glassEffect,
            border: `1px solid ${theme === "white" ? colors.border : `${colors.primary}15`}`,
          }}
        >
          {/* Chart Type Toggle Icon */}
          <div className="absolute top-4 right-6 z-10 flex gap-2 export-ignore">
            <button
              onClick={() =>
                setMainChartType(mainChartType === "line" ? "bar" : "line")
              }
              className="p-2 rounded-lg transition-all border hover:shadow-md"
              style={{
                backgroundColor: colors.background,
                borderColor: colors.border,
                color: colors.primary,
              }}
              title={
                mainChartType === "line"
                  ? "Switch to Bar Chart"
                  : "Switch to Line Chart"
              }
            >
              {mainChartType === "line" ? (
                <BarChart3 size={18} />
              ) : (
                <Activity size={18} />
              )}
            </button>
          </div>

          <div className="h-[400px] min-[1921px]:h-[500px] max-[800px]:w-[600px]">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <Spin size="large" />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                {mainChartType === "line" ? (
                  <LineChart
                    data={merge}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                      vertical={false}
                    />
                    <XAxis
                      dataKey="date"
                      stroke="#BDB9B5"
                      style={{ fontSize: "10px" }}
                      tickMargin={10}
                      tickFormatter={(value) => {
                        const date = moment(value);
                        if (!date.isValid()) return value;
                        return optiononenew === "Months"
                          ? date.format("MMM YYYY")
                          : date.format("MMM DD, YYYY");
                      }}
                    />
                    <YAxis
                      stroke="#BDB9B5"
                      style={{ fontSize: "10px" }}
                      tickFormatter={(val) => val.toLocaleString()}
                    >
                      <Label
                        value="Gallons"
                        angle={-90}
                        position="insideLeft"
                        offset={-10}
                        style={{ fill: "#BDB9B5", fontSize: "12px" }}
                      />
                    </YAxis>
                    <Tooltip
                      contentStyle={{
                        backgroundColor:
                          theme === "white" ? "#ffffff" : colors.background,
                        border: `1px solid ${colors.primary}30`,
                        borderRadius: "4px",
                      }}
                      labelStyle={{
                        color: colors.text,
                        fontWeight: "bold",
                        marginBottom: "4px",
                      }}
                      formatter={(value, name) => [
                        `${value.toLocaleString()} Gallons`,
                        name,
                      ]}
                    />
                    <Legend
                      iconType="circle"
                      wrapperStyle={{ paddingTop: "20px" }}
                    />
                    {/* {myDatas.map((item, index) => (
                      <Line
                        key={item.meter}
                        type="monotone"
                        dataKey={item.meter}
                        stroke={color[index % color.length]}
                        strokeWidth={2}
                        dot={{ fill: color[index % color.length], r: 4 }}
                        name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                      />
                    ))} */}
                    {myDatas.length > 0 ? (
                      // NOT NULL CASE: Plot specific meters
                      myDatas.map((item, index) => (
                        <Line
                          key={item.meter}
                          type="monotone"
                          dataKey={item.meter}
                          stroke={color[index % color.length]}
                          name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                          // ...other props
                        />
                      ))
                    ) : (
                      // NULL CASE: Plot the generic flow
                      <Line
                        type="monotone"
                        dataKey="Total Flow"
                        stroke={colors.primary}
                        name="Total Demand"
                        strokeWidth={3}
                        dot={{ r: 6 }}
                      />
                    )}
                  </LineChart>
                ) : (
                  <BarChart
                    data={merge}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                      vertical={false}
                    />
                    <XAxis
                      dataKey="date"
                      stroke="#BDB9B5"
                      style={{ fontSize: "10px" }}
                      tickMargin={10}
                      tickFormatter={(value) => {
                        const date = moment(value);
                        if (!date.isValid()) return value;
                        return optiononenew === "Months"
                          ? date.format("MMM YYYY")
                          : date.format("MMM DD, YYYY");
                      }}
                    />
                    <YAxis
                      stroke="#BDB9B5"
                      style={{ fontSize: "10px" }}
                      tickFormatter={(val) => val.toLocaleString()}
                    >
                      <Label
                        value="Gallons"
                        angle={-90}
                        position="insideLeft"
                        style={{ fill: "#BDB9B5", fontSize: "12px" }}
                      />
                    </YAxis>
                    <Tooltip
                      cursor={{ fill: "rgba(255,255,255,0.05)" }}
                      labelStyle={{
                        color: colors.text,
                        fontWeight: "bold",
                        marginBottom: "4px",
                      }}
                      contentStyle={{
                        backgroundColor:
                          theme === "white" ? "#ffffff" : colors.background,
                        border: `1px solid ${colors.primary}30`,
                        borderRadius: "8px",
                      }}
                      formatter={(value, name) => [
                        `${value.toLocaleString()} Gallons`,
                        name,
                      ]}
                    />
                    <Legend
                      iconType="circle"
                      wrapperStyle={{ paddingTop: "20px" }}
                    />
                    {/* {myDatas.map((item, index) => (
                      <Bar
                        key={item.meter}
                        dataKey={item.meter}
                        fill={color[index % color.length]}
                        name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                        radius={[4, 4, 0, 0]}
                        barSize={myData.length > 4 ? 15 : 30}
                      />
                    ))} */}
                    {/* Inside BarChart */}

                    {myDatas.length > 0 ? (
                      // NOT NULL CASE: Plot specific meters as separate bars
                      myDatas.map((item, index) => (
                        <Bar
                          key={item.meter}
                          dataKey={item.meter}
                          fill={color[index % color.length]}
                          name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                          radius={[4, 4, 0, 0]}
                          // Dynamic bar size based on number of meters
                          barSize={myData.length > 4 ? 15 : 30}
                        />
                      ))
                    ) : (
                      // NULL CASE: Plot the generic aggregate flow as one wide bar
                      <Bar
                        dataKey="Total Flow"
                        fill={colors.primary}
                        name="Aggregate Flow"
                        radius={[4, 4, 0, 0]}
                        barSize={40} // Wider bar for better visibility in aggregate mode
                      />
                    )}
                  </BarChart>
                )}
              </ResponsiveContainer>
            )}
          </div>
        </motion.div>

        {/* View Type Toggle */}
        <motion.div
          className="flex gap-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <button
            onClick={() => setToggle(false)}
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg border transition-all duration-300"
            style={{
              background: !toggle ? `${colors.primary}20` : colors.cardBg,
              borderColor: !toggle ? colors.primary : colors.border,
              color: !toggle ? colors.primary : colors.textSecondary,
            }}
          >
            <Calendar className="w-4 h-4" />
            <span className="text-sm font-semibold">Daily Average</span>
          </button>

          <button
            onClick={() => setToggle(true)}
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg border transition-all duration-300"
            style={{
              background: toggle ? `${colors.primary}20` : colors.cardBg,
              borderColor: toggle ? colors.primary : colors.border,
              color: toggle ? colors.primary : colors.textSecondary,
            }}
          >
            <BarChart3 className="w-4 h-4" />
            <span className="text-sm font-semibold">Hourly Average</span>
          </button>
        </motion.div>

        {/* Bottom Chart (Switches between Bar for Daily, Line for Hourly) & Optional Sidebar */}
        <motion.div
          className="backdrop-blur-sm rounded-xl p-6 relative flex gap-6 max-[800px]:overflow-x-scroll"
          style={{
            background: colors.cardBg,
            border: `1px solid ${colors.border}`,
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <div className="absolute top-4 right-6 z-10 export-ignore">
            <button
              onClick={() =>
                setBottomChartType(bottomChartType === "line" ? "bar" : "line")
              }
              className="flex items-center justify-center w-9 h-9 rounded-lg border transition-all hover:bg-white/10"
              style={{ borderColor: colors.border, color: colors.primary }}
            >
              {bottomChartType === "line" ? (
                <BarChart3 size={18} />
              ) : (
                <Activity size={18} />
              )}
            </button>
          </div>
          {/* <div className="max-[800px]:w-[600px] max-[800px]:overflow-x-scroll"> */}
          {/* Radio Sidebar specifically for Hourly Average */}
          <AnimatePresence>
            {toggle && (
              <motion.div
                initial={{ width: 0, opacity: 0 }}
                animate={{ width: 140, opacity: 1 }}
                exit={{ width: 0, opacity: 0 }}
                className="flex flex-col gap-3 shrink-0 pr-4 overflow-hidden"
                style={{
                  borderRight: `1px solid ${colors.border}`,
                }}
              >
                {dayOptions.map((day) => (
                  <label
                    key={day.id}
                    className="flex items-center gap-3 cursor-pointer group"
                  >
                    <div className="relative flex items-center justify-center">
                      <input
                        type="radio"
                        name="hourlyDay"
                        value={day.id}
                        checked={selectedDayOption === day.id}
                        onChange={(e) => setSelectedDayOption(e.target.value)}
                        className="appearance-none w-4 h-4 rounded-full transition-colors cursor-pointer"
                        style={{
                          border: `1px solid ${
                            selectedDayOption === day.id
                              ? colors.primary
                              : colors.textSecondary
                          }`,
                        }}
                      />
                      {selectedDayOption === day.id && (
                        <div
                          className="absolute w-2 h-2 rounded-full"
                          style={{ background: colors.primary }}
                        />
                      )}
                    </div>
                    <span
                      style={{
                        color:
                          selectedDayOption === day.id
                            ? colors.text
                            : colors.textSecondary,
                      }}
                      className="text-sm whitespace-nowrap transition-colors font-medium"
                    >
                      {day.label}
                    </span>
                  </label>
                ))}
              </motion.div>
            )}
          </AnimatePresence>

          <div className="flex-1 h-[400px] min-[1921px]:h-[500px] max-[800px]:min-w-[800px] w-full">
            {loadings ? (
              <div className="flex items-center justify-center h-full">
                <Spin size="large" />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                {/* {toggle ? (
                  <LineChart
                    data={mergenew}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                      vertical={false}
                    />
                    <XAxis
                      dataKey="day"
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 10 }}
                      tickMargin={10}
                    />
                    <YAxis
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 10 }}
                      tickFormatter={(value) => value.toLocaleString("en-US")}
                    >
                      <Label
                        value="Gallons"
                        angle={-90}
                        position="insideLeft"
                        style={{ fill: colors.textSecondary, fontSize: "12px" }}
                      />
                    </YAxis>
                    <Tooltip
                      contentStyle={{
                        backgroundColor: colors.background,
                        border: `1px solid ${colors.border}`,
                        borderRadius: "8px",
                        color: colors.text,
                      }}
                      formatter={(value, name) => [
                        `${Number(value).toLocaleString()} Gallons`,
                        name,
                      ]}
                    />
                    <Legend
                      iconType="circle"
                      wrapperStyle={{ paddingTop: "20px" }}
                    />
                    {myDatas.map((item, index) => (
                      <Line
                        key={item.meter}
                        type="monotone"
                        dataKey={item.meter}
                        stroke={color[index % color.length]}
                        strokeWidth={2}
                        dot={{ fill: color[index % color.length], r: 4 }}
                        name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                        isAnimationActive={true}
                      />
                    ))}
                  </LineChart>
                ) : (
                  <BarChart
                    data={mergenew}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                      vertical={false}
                    />
                    <XAxis
                      dataKey="day"
                      stroke={colors.textSecondary}
                      tickFormatter={(value) => {
                        const date = moment(value);

                        if (!date.isValid()) {
                          return value;
                        }
                        return date.format("dddd");
                      }}
                      tick={{ fill: colors.textSecondary, fontSize: 10 }}
                    />
                    <YAxis
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 10 }}
                      tickFormatter={(value) => value.toLocaleString("en-US")}
                    >
                      <Label
                        value="Gallons"
                        angle={-90}
                        position="insideLeft"
                        style={{ fill: colors.textSecondary, fontSize: "12px" }}
                      />
                    </YAxis>
                    <Tooltip
                      cursor={{ fill: "rgba(255,255,255,0.05)" }}
                      contentStyle={{
                        backgroundColor: colors.background,
                        border: `1px solid ${colors.border}`,
                        borderRadius: "8px",
                        color: colors.text,
                      }}
                    />
                    <Legend
                      iconType="circle"
                      wrapperStyle={{ paddingTop: "20px" }}
                    />
                    {myDatas.map((item, index) => (
                      <Bar
                        key={item.meter}
                        dataKey={item.meter}
                        fill={color[index % color.length]}
                        // name={item.meter}
                        name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                        radius={[4, 4, 0, 0]}
                        barSize={myData.length > 4 ? 20 : 40}
                      />
                    ))}
                  </BarChart>
                )} */}
                {bottomChartType === "line" ? (
                  <LineChart
                    data={mergenew}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                      vertical={false}
                    />
                    <XAxis
                      dataKey="day"
                      stroke={colors.textSecondary}
                      tick={{ fill: colors.textSecondary, fontSize: 10 }}
                      tickMargin={10}
                    />
                    <YAxis
                      stroke={colors.textSecondary}
                      tickFormatter={(val) => val.toLocaleString()}
                      width={100}
                    >
                       <Label
                        value="Gallons"
                        angle={-90}
                        position="insideLeft"
                        offset={-10}
                        style={{ fill: colors.textSecondary, fontSize: "12px" }}
                      />
                    </YAxis>
                    <Tooltip
                      // contentStyle={{
                      //   backgroundColor: colors.background,
                      //   borderRadius: "8px",
                      // }}
                      labelStyle={{
                        color: colors.text,
                        fontWeight: "bold",
                        marginBottom: "4px",
                      }}
                      contentStyle={{
                        backgroundColor:
                          theme === "white" ? "#ffffff" : colors.background,
                        border: `1px solid ${colors.primary}30`,
                        borderRadius: "4px",
                      }}
                    />
                    <Legend iconType="circle" />
                    {/* {myDatas.map((item, index) => (
                      <Line
                        key={item.meter}
                        type="monotone"
                        dataKey={item.meter}
                        stroke={color[index % color.length]}
                        strokeWidth={2}
                        dot={{ r: 4 }}
                        name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                      />
                    ))} */}
                    {myDatas.length > 0 ? (
                      // NOT NULL: Show specific meters
                      myDatas.map((item, index) => (
                        <Line
                          key={item.meter}
                          type="monotone"
                          dataKey={item.meter}
                          stroke={color[index % color.length]}
                          strokeWidth={2}
                          name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                        />
                      ))
                    ) : (
                      // NULL CASE: Show aggregate line
                      <Line
                        type="monotone"
                        dataKey="Total Flow"
                        stroke={colors.primary}
                        name={
                          toggle
                            ? "Total Demand Hourly Avg"
                            : "Total Demand Daily Avg"
                        }
                        strokeWidth={3}
                        dot={{ r: 4 }}
                      />
                    )}
                  </LineChart>
                ) : (
                  <BarChart
                    data={mergenew}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke={colors.border}
                      vertical={false}
                    />

                    <XAxis
                      dataKey="day"
                      stroke={colors.textSecondary}
                      tickFormatter={(value) => {
                        const date = moment(value);

                        if (!date.isValid()) {
                          return value;
                        }
                        return date.format("dddd");
                      }}
                      tick={{ fill: colors.textSecondary, fontSize: 10 }}
                    />
                    <YAxis
                      stroke={colors.textSecondary}
                      tickFormatter={(val) => val.toLocaleString()}
                    />
                    <Tooltip
                      cursor={{ fill: "rgba(255,255,255,0.05)" }}
                      // contentStyle={{
                      //   backgroundColor: colors.background,
                      //   borderRadius: "8px",
                      // }}
                      labelStyle={{
                        color: colors.text,
                        fontWeight: "bold",
                        marginBottom: "4px",
                      }}
                      contentStyle={{
                        backgroundColor:
                          theme === "white" ? "#ffffff" : colors.background,
                        border: `1px solid ${colors.primary}30`,
                        borderRadius: "4px",
                      }}
                    />
                    <Legend iconType="circle" />
                    {/* {myDatas.map((item, index) => (
                      <Bar
                        key={item.meter}
                        dataKey={item.meter}
                        fill={color[index % color.length]}
                        radius={[4, 4, 0, 0]}
                        barSize={myData.length > 4 ? 20 : 40}
                        name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                      />
                    ))} */}
                    {myDatas.length > 0 ? (
                      myDatas.map((item, index) => (
                        <Bar
                          key={item.meter}
                          dataKey={item.meter}
                          fill={color[index % color.length]}
                          radius={[4, 4, 0, 0]}
                          name={`${item.accountName ? item.accountName + " - " : ""}${item.meter}`}
                        />
                      ))
                    ) : (
                      <Bar
                        dataKey="Total Flow"
                        fill={colors.primary}
                        name={
                          toggle
                            ? "Total Demand Hourly Avg"
                            : "Total Demand Daily Avg"
                        }
                        radius={[4, 4, 0, 0]}
                        barSize={40}
                      />
                    )}
                  </BarChart>
                )}
              </ResponsiveContainer>
            )}
          </div>

          {/* </div> */}
        </motion.div>
      </div>
    </div>
  );
};

export default WaterUsageTab;
